<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { generateBreadcrumbsForUrl } from '@/services/navigationService'
import { __ } from '@/utils/utils'

defineProps({
  title: String,
  subTitle: String,
  logo: String,
  backgroundLogo: String
})

const lang = ref<any>()
const breadcrumbs = ref<any>([])
const siteUrl = `${document.location.origin}/`
const route = useRoute()
const lvl3Index = ref<any>(0)
const savedLang = ref<string>('')

const isUfcPage = computed(() => route.params.slug === 'ufc')
const isAtleticoPage = computed(() => route.params.slug === 'atletico-de-madrid')
const isFortalezaPage = computed(() => route.params.slug === 'fortaleza')

const isJapaneseUfcTitle = computed(() => savedLang.value === 'jp' && isUfcPage.value)
const isJapaneseAtleticoTitle = computed(() => savedLang.value === 'jp' && isAtleticoPage.value)
const isJapaneseFortalezaTitle = computed(() => savedLang.value === 'jp' && isFortalezaPage.value)

onMounted(async () => {
  breadcrumbs.value = await generateBreadcrumbsForUrl('company', route.params.menu_second as string)
  lvl3Index.value = breadcrumbs.value.findIndex((item: any) => item.url === route.params.slug)
  savedLang.value = localStorage.getItem('lang') || ''

  lang.value =
    savedLang.value !== '' &&
    savedLang.value !== 'undefined' &&
    savedLang.value !== 'en'
      ? savedLang.value + '/'
      : ''
})
</script>
<template>
  <div
    v-if="backgroundLogo"
    :class="`bg-black  bg-cover bg-no-repeat bg-center`"
    :style="{ backgroundImage: `url('${backgroundLogo}')` }"
  >
    <div class="flex flex-col items-center pb-20 lg:pt-10 lg:pl-30 lg:items-start">
      <div class="gap-[2px] flex self-start lg:pl-0 pl-[10px] lg:pt-0 pt-[20px]">
        <a :href="`${siteUrl}${lang}`" class="text-red-150">{{ __('Home') }}</a>
        <span class="text-white">></span>
        <a :href="`${siteUrl}${lang}company/contact-us/`" class="text-red-150">
          {{ breadcrumbs[0]?.title }}
        </a>
        <span class="text-white">></span>
        <a :href="`${siteUrl}${lang}company/sponsorships/`" class="text-red-150">
          {{ __('Sponsorships') }}
        </a>
        <div>
          <span class="text-white">></span>
          <a class="text-white pointer-events-none">{{ breadcrumbs[lvl3Index]?.title }}</a>
        </div>
      </div>
      <div
        class="flex flex-col lg:flex-row lg:mt-[101px] mt-[37px] gap-10 lg:gap-6 md:px-20 lg:pl-0 lg:pr-[40px] w-full"
      >
        <div class="flex lg:min-w-[170px] items-center justify-center lg:justify-start lg:items-start lg:pt-6">
          <img :src="logo" loading="lazy" />
        </div>
        <div>
          <div
            v-if="isJapaneseUfcTitle"
            class="self-center text-center text-wrap text-white lg:h1-bold h3-bold lg:self-start lg:text-start"
          >
            <span class="whitespace-nowrap">ハンテック・マーケッツが</span>
            <span class="whitespace-nowrap">UFCの公式APAC</span>
            <span class="whitespace-nowrap">取引パートナーに。</span>
          </div>
          <div
            v-if="isJapaneseAtleticoTitle"
            class="jp-sponsorship-title self-center text-center text-wrap text-white lg:h1-bold h3-bold lg:self-start lg:text-start"
          >
            <span class="whitespace-nowrap">ハンテック マーケッツは</span>
            <span class="whitespace-nowrap">アトレティコ・マドリードと</span>
            <span class="whitespace-nowrap">提携しています。</span>
          </div>
          <div
            v-if="isJapaneseFortalezaTitle"
            class="jp-sponsorship-title self-center text-center text-wrap text-white lg:h1-bold h3-bold lg:self-start lg:text-start"
          >
            <span class="whitespace-nowrap">ハンテック マーケッツは</span>
            <span class="whitespace-nowrap">フォルタレザECと</span>
            <span class="whitespace-nowrap">提携しています。</span>
          </div>
          <div
            v-if="savedLang !== 'jp'"
            class="self-center text-center text-wrap text-white lg:h1-bold h3-bold lg:self-start lg:text-start lg:max-w-[850px]"
            v-html="title"
          ></div>
          <div
            v-if="isJapaneseUfcTitle"
            class="self-center text-white h6-bold lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center lg:text-left lg:px-0 px-[10px]"
          >
            <span class="whitespace-nowrap hidden sm:inline">エリートスポーツと金融市場を結びつけ、APAC（アジア太平洋地域）全体に</span>
            <span class="sm:hidden whitespace-nowrap">エリートスポーツと金融市場を結びつけ、</span>
            <span class="sm:hidden whitespace-nowrap">APAC（アジア太平洋地域）全体に</span>
            <span class="whitespace-nowrap">自信、</span>
            <span class="whitespace-nowrap">規律、</span>
            <span class="whitespace-nowrap">野心を</span>
            <span class="whitespace-nowrap">呼び起こ</span>
            <span class="whitespace-nowrap">します。</span>
          </div>
          <div
            v-if="isJapaneseAtleticoTitle"
            class="jp-sponsorship-title self-center text-white h6-bold lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center lg:text-left lg:px-0 px-[10px]"
          >
            <span class="whitespace-nowrap">ハンテック マーケッツはアトレティコ・マドリードの</span>
            <span class="whitespace-nowrap">ラテンアメリカ公式オンライン取引パートナーである</span>
            <span class="whitespace-nowrap">ことを誇りに思います。</span>
          </div>
          <div
            v-if="isJapaneseFortalezaTitle"
            class="jp-sponsorship-title self-center text-white h6-bold lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center lg:text-left lg:px-0 px-[10px]"
          >
            <span class="whitespace-nowrap">ハンテック マーケッツはフォルタレザECの</span>
            <span class="whitespace-nowrap">公式取引パートナーであることを</span>
            <span class="whitespace-nowrap">誇りに思います。</span>
          </div>
          <div
            v-if="savedLang !== 'jp'"
            class="self-center text-white lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center lg:text-left md:px-20 lg:px-0 px-[10px] lg:max-w-[600px]"
            v-html="subTitle"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.jp-sponsorship-title {
  text-wrap: wrap;
}
</style>
